import { GetIncentivoImpiantoQuery } from '../../_graphql/generated';

export type IncentivoImpiantoState = {
  loading: boolean;
  lista: GetIncentivoImpiantoQuery['energy_village_incentivo_impianto'];
  failure: any;
};

export const initialIncentivoImpiantoState: IncentivoImpiantoState = {
  loading: false,
  lista: [],
  failure: '',
};
